import { render } from "./CompareValue.vue?vue&type=template&id=4642f4d1&scoped=true"
import script from "./CompareValue.vue?vue&type=script&lang=js"
export * from "./CompareValue.vue?vue&type=script&lang=js"

import "./CompareValue.vue?vue&type=style&index=0&id=4642f4d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4642f4d1"]])

export default __exports__